export default "__VITE_ASSET__CKEGFCbR__"